import React from 'react';
import { Table, Empty } from 'antd';

export default function MetodoPago(props) {
    return (
        <div>
            <Table
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText:
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='No se encontraron datos'
                        />
                }}
                columns={[
                    {
                        title: 'Fecha',
                        dataIndex: 'fechaPagoStr',
                        key: 'fechaPagoStr'
                    },
                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'nombreMetodoPago',
                        key: 'nombreMetodoPago'
                    },
                    {
                        title: 'Cuenta',
                        dataIndex: 'numeroCuenta',
                        key: 'numeroCuenta'
                    },
                    {
                        title: 'Nro Operación',
                        dataIndex: 'referencia',
                        key: 'referencia'
                    },
                    {
                        title: 'Monto',
                        dataIndex: 'montoPago',
                        key: 'montoPago',
                        render: (data) => (
                            <span>{data.toFixed(2)}</span>
                        )
                    }
                ]}
            />
        </div>
    );
}